import * as React from "react";
import { useMediaQuery } from "react-responsive";
import { Accordion } from "../accordion/accordion/accordion.mjs";
import { Grid } from "../grid/grid/grid.mjs";
import "debounce";
import "tabbable";
import { useIsMounted } from "../helpers/helper/hooks/use-is-mounted.mjs";
import { useTheme } from "../helpers/theme-provider/use-theme.mjs";
const AccordionGridContext = React.createContext({
  headingLevel: void 0,
  isSmallScreen: void 0
});
const AccordionGrid = ({ grid, children, accordion, headingLevel = 2, breakPoint = "sm" }) => {
  const isMounted = useIsMounted();
  const { media } = useTheme();
  const isLargeScreen = useMediaQuery({
    minWidth: media.width[breakPoint].min
  });
  const accordionGridContextValue = {
    headingLevel,
    isSmallScreen: isMounted && !isLargeScreen
  };
  return /* @__PURE__ */ React.createElement(AccordionGridContext.Provider, { value: accordionGridContextValue }, isMounted && !isLargeScreen ? /* @__PURE__ */ React.createElement(Accordion, { ...accordion, headingLevel }, children) : /* @__PURE__ */ React.createElement(Grid, { ...grid }, children));
};
export {
  AccordionGrid,
  AccordionGridContext
};
